import { render, staticRenderFns } from "./PageRegistration.vue?vue&type=template&id=d8d82dd6&scoped=true&"
import script from "./PageRegistration.vue?vue&type=script&lang=js&"
export * from "./PageRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PageRegistration.vue?vue&type=style&index=0&id=d8d82dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d82dd6",
  null
  
)

export default component.exports